export const serializeAEMCookieCollection =
  <T>(serializeItem: (item: T) => string, splitter = ';') =>
  (itemsCollection: T[] = []): string => {
    const result: string = encodeURIComponent(itemsCollection.map(serializeItem).join(splitter));
    return result;
  };
